import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { CommonService } from '../../services';
import { Observable } from 'rxjs';

import { SystemHelpers } from '../../helpers';

@Component({
  selector: 'app-select',
  templateUrl: './app-select.component.html',
  providers: [CommonService]
})

export class AppSelectComponent implements OnChanges, OnInit {

  public data: Object[];
  public label: string;
  @Input() mode: string;
  @Input() value: string;
  @Input() type: string;
  @Input() selected;
  @Input() results: any[] = null;
  @Output() notify: EventEmitter<any> = new EventEmitter<any>();

  constructor(private commonService: CommonService) { }

  ngOnInit() {
    let sub: Observable<Object[]>;
    switch (this.type) {
      case 'sector':
        sub = this.commonService.getSectors();
        this.label = 'Choose a sector';
        break;
      case 'type':
        sub = this.commonService.getTypes();
        this.label = 'Choose a type';
        break;
      case 'faculty_tag':
        sub = this.commonService.getFaculties();
        this.label = 'Select faculty';
        break;
      case 'vote':
        this.data = this.getVote();
        this.label = 'Select graduation vote';
        break;
      case 'language_level':
        this.data = this.getLanguageLevel();
        this.label = 'Select Language level';
        break;
      case 'study_tag': {
        const data = [];
        if (this.results && this.results.length > 0) {
          this.results.forEach(d => {
            data.push({
              value: d['id'] ? d['id'] : d['tag'],
              label: d['name_en'] ? d['name_en'] : SystemHelpers.facultyTrans(d['tag'])
            })
          });
        }
        this.data = data;
        this.label = 'Select Study tag';
        break;
      }
      case 'macro_study_tags': {
        const data = [];
        if (this.results && this.results.length > 0) {
          this.results.forEach(d => {
            data.push({
              value: d['tag'] ? d['tag'] : d['tag'],
              label: SystemHelpers.facultyTrans(d['tag'])
            })
          });
        }
        this.data = data;
        console.log('macro_study_tags', this.data);
        this.label = 'Select Study tag';
        break;
      }
    }
    if (sub) {
      sub.subscribe(data => {
        const formatted = [];
        data.forEach(d => {
          formatted.push({
            value: d['id'] ? d['id'] : d['tag'],
            label: d['name_en'] ? d['name_en'] : SystemHelpers.facultyTrans(d['tag'])
          })
        });
        this.data = formatted;
      });
    }
  }

  ngOnChanges(event: SimpleChanges) {
    if (event.results && !event.results.isFirstChange()) {
      this.ngOnInit();
    }
    if (event['value'] && !event['value']['currentValue']) {
      this.selected = '';
      this.notify.emit();
    } else if (event['value'] && event['value']['currentValue']) {
      this.selected = event['value']['currentValue'];
    }
  }

  getVote() {
    const votes = [];
    let votes_range = 110;
    while (votes_range > 89) {
      votes.push(votes_range);
      votes_range--;
    }
    const result = [];
    for (let i = 0; i < votes.length; i++) {
      result.push({
        value: votes[i],
        label: '> ' + votes[i]
      });
    }
    return result;
  }

  getLanguageLevel() {
    return [
      { value: 'A1', label: '> A1' },
      { value: 'A2', label: '> A2' },

      { value: 'B1', label: '> B1' },
      { value: 'B2', label: '> B2' },

      { value: 'C1', label: '> C1' },
      { value: 'C2', label: 'C2' }
    ];
  }

  // changed(event) {
  //   this.notify.emit({
  //     type: this.type,
  //     id: event
  //   });
  // }

  typeaheadOnSelect(event) {
    this.notify.emit({
      type: this.type,
      id: event.item.value,
      value: event.item.label
    });

  }
}
